import { useEffect, useState } from "react";
import DatePicker from "react-date-picker";
import { onlyDigitsNumbers } from "../../common/components/TemplateContainer/InputTemplates";

import { FILTERS } from "../../utils/constants";
import { dateToISO } from "../../utils/dates";
import { DAM_MAX_LENGTH } from "../../utils/valueStaticConstants";
import {
  DamInput,
  DamSuffix,
} from "../BillingSearchBar/BillingSearchBarStyles";
import Input from "../Input/Input";
import MultiSelectStyled from "../MultiSelectStyled/MultiSelectStyled";
import { SearchBar } from "../Payment/FilterStyles";
import { SearchButton } from "../SearchButtons/SearchButtons";
import Select from "../Select/Select";

const weekAgo = new Date();
weekAgo.setDate(weekAgo.getDate());

export const INITIAL_FILTERS = {
  consignee: "",
  year: FILTERS.VALIDATION.YEARS[0],
  regimenId: FILTERS.VALIDATION.REGIMES[0].id,
  damSuffix: "",
  status: [],
  lastUpdate: weekAgo,
};

const SenasaDamsFilter = ({ onQuery }) => {
  const [filters, updateFilters] = useState(INITIAL_FILTERS);
  const onConsigneeChange = (ev) =>
    updateFilters((filters) => ({ ...filters, consignee: ev.target.value }));

  const onRegimenChange = (ev) =>
    updateFilters((filters) => ({ ...filters, regimenId: ev.target.value }));
  const onYearChange = (ev) =>
    updateFilters((filters) => ({ ...filters, year: ev.target.value }));
  const onDamSuffixChange = (ev) => {
    const text = ev.target.value;
    if (text.length < 7) {
      updateFilters((filters) => ({ ...filters, damSuffix: text }));
    }
  };
  const onStatusListUpdate = (ev) =>
    updateFilters((filters) => ({ ...filters, status: ev.target.value }));

  useEffect(() => {
    updateFilters(INITIAL_FILTERS);
  }, []);
  return (
    <SearchBar hmargin={true} dateHeight="4.5rem" dateWidth="max(16rem, 130px)">
      <div className="box">
        <h3>Consignatario:</h3>
        <Input
          width="40rem"
          type="text"
          placeholder="HP INC PERÚ"
          value={filters.consignee}
          onChange={onConsigneeChange}
        />
      </div>
      <div className="box">
        <h3>Año:</h3>
        <Select
          className="clickable-element"
          name="regimen"
          onChange={onYearChange}
          onBlur={onYearChange}
          width="9rem"
          height="4.5rem"
          arrowPosition="1.6rem"
          value={filters.year}
        >
          {FILTERS.VALIDATION.YEARS.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </Select>
      </div>

      <div className="box">
        <h3>Régimen:</h3>
        <Select
          className="clickable-element"
          name="regimen"
          onChange={onRegimenChange}
          onBlur={onRegimenChange}
          height="4.5rem"
          arrowPosition="1.6rem"
          value={filters.regimenId}
        >
          {FILTERS.VALIDATION.REGIMES.map((regimen) => (
            <option key={regimen.id} value={regimen.id}>
              {`${regimen.id}: ${regimen.name}`}
            </option>
          ))}
        </Select>
      </div>

      <div className="dam--container">
        <h3>Número de DAM:</h3>
        <DamInput>
          <div className="dam-prefix">{`235-${filters.year}-${filters.regimenId}`}</div>
          <DamSuffix
            type="text"
            className="DAMSuffix"
            placeholder={`123456`}
            value={filters.damSuffix}
            onChange={onDamSuffixChange}
            onKeyPress={onlyDigitsNumbers}
            maxLength={DAM_MAX_LENGTH}
          />
        </DamInput>
      </div>
      <div className="box">
        <h3>Estado:</h3>
        <MultiSelectStyled
          height="4.5rem"
          width="27rem"
          selectItems={FILTERS.VALIDATION.STATUS}
          info={filters.status}
          onInfoChange={onStatusListUpdate}
        />
      </div>
      <div className="box">
        <h3>Última actualización:</h3>
        <DatePicker
          value={filters.lastUpdate}
          onChange={(value) =>
            updateFilters((filters) => ({ ...filters, lastUpdate: value }))
          }
          clearIcon={null}
          locale={"es-PE"}
          showLeadingZeros={true}
          dayPlaceholder={"dd"}
          monthPlaceholder={"mm"}
          yearPlaceholder={"aa"}
        />
      </div>
      <div className="search-button--container box">
        <SearchButton onClick={() => onQuery(filters)} />
      </div>
    </SearchBar>
  );
};

export default SenasaDamsFilter;

export function formatFilters(filters) {
  const { damSuffix, year, regimenId } = filters;
  const damNum = damSuffix ? `235-${year}-${regimenId}-${damSuffix}` : "";
  const status =
    filters.status.length > 0
      ? filters.status.map((e) => e.toLowerCase())
      : FILTERS.VALIDATION.STATUS.map((e) => e.value.toLowerCase());
  const params = {
    senasa_status_option: status,
    consignee_name: filters.consignee,
    dam_num: damNum,
    from_date: dateToISO(filters.lastUpdate),
  };

  Object.entries(params).forEach(([key, val]) => {
    if (!val) {
      delete params[key];
    }
  });
  return params;
}
